/** Public assets under `public/images/file-types/` — respects Vite `BASE_URL`. */
export function getChatFileTypeAssetUrl(fileName: string): string {
  const base = import.meta.env.BASE_URL || '/';
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  return `${normalizedBase}images/file-types/${fileName}`;
}

export const CHAT_FILE_TYPE_ICONS = {
  pdf: getChatFileTypeAssetUrl('pdf.png'),
  docx: getChatFileTypeAssetUrl('docx_icon.png'),
  xlsx: getChatFileTypeAssetUrl('xlsx.png'),
  zip: getChatFileTypeAssetUrl('zip.png'),
} as const;

export type ChatDocumentKind = keyof typeof CHAT_FILE_TYPE_ICONS | 'unknown';
